import { c as _c } from "react/compiler-runtime";
import { Button } from '@achra/ui/button';
import { Card, CardContent } from '@achra/ui/card';
import { cn } from '@achra/ui/lib/utils';
import Image from 'next/image';
import Link from 'next/link';
import { SERVICE_INFO_DEFAULT_COVER_PATH } from '../../lib/constants';
import { ServiceBadge } from '../service-badge';
import type { EnrichedService } from '../../types';
import type { Route } from 'next';
interface ServiceFeaturedCardProps {
  enrichedService: EnrichedService;
  primary?: boolean;
}
function ServiceFeaturedCard(t0) {
  const $ = _c(56);
  const {
    enrichedService,
    primary: t1
  } = t0;
  const primary = t1 === undefined ? false : t1;
  const {
    service,
    badge,
    offeringSummary,
    operatorName
  } = enrichedService;
  const isComingSoon = badge === "coming-soon";
  const showFreeTier = offeringSummary?.hasFreeTier;
  const coverImage = service.thumbnailUrl ?? SERVICE_INFO_DEFAULT_COVER_PATH;
  const t2 = primary ? "col-span-1 p-0 sm:col-span-2" : "col-span-1 p-0";
  let t3;
  if ($[0] !== t2) {
    t3 = cn("bg-card hover:border-border relative overflow-hidden border border-transparent transition-[box-shadow,border-color] duration-200 ease-out hover:shadow-lg", t2);
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = `/services/${service.id}` as Route;
  const t5 = `${service.title} Profile`;
  let t6;
  if ($[2] !== t4 || $[3] !== t5) {
    t6 = <Link href={t4} className="absolute inset-0 z-10 rounded-xl" aria-label={t5} />;
    $[2] = t4;
    $[3] = t5;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  const t7 = primary && "sm:gap-5 sm:p-5";
  let t8;
  if ($[5] !== t7) {
    t8 = cn("flex h-full gap-4 p-4", t7);
    $[5] = t7;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  const t9 = primary ? "size-12 sm:size-14" : "size-10 sm:size-12";
  let t10;
  if ($[7] !== t9) {
    t10 = cn("relative shrink-0 overflow-hidden rounded-lg", t9);
    $[7] = t9;
    $[8] = t10;
  } else {
    t10 = $[8];
  }
  let t11;
  if ($[9] !== coverImage || $[10] !== service.title) {
    t11 = <Image src={coverImage} alt={service.title} fill={true} unoptimized={true} className="rounded-lg object-cover" />;
    $[9] = coverImage;
    $[10] = service.title;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] !== t10 || $[13] !== t11) {
    t12 = <div className={t10}>{t11}</div>;
    $[12] = t10;
    $[13] = t11;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== badge || $[16] !== primary) {
    t13 = !primary && badge && <ServiceBadge badge={badge} />;
    $[15] = badge;
    $[16] = primary;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  const t14 = primary ? "text-sm sm:text-lg" : "text-sm sm:text-base";
  let t15;
  if ($[18] !== t14) {
    t15 = cn("text-foreground leading-tight font-bold", t14);
    $[18] = t14;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] !== service.title || $[21] !== t15) {
    t16 = <span className={t15}>{service.title}</span>;
    $[20] = service.title;
    $[21] = t15;
    $[22] = t16;
  } else {
    t16 = $[22];
  }
  let t17;
  if ($[23] !== operatorName) {
    t17 = operatorName && <span className="text-muted-foreground text-xs">by {operatorName}</span>;
    $[23] = operatorName;
    $[24] = t17;
  } else {
    t17 = $[24];
  }
  let t18;
  if ($[25] !== t13 || $[26] !== t16 || $[27] !== t17) {
    t18 = <div className="flex min-w-0 flex-1 flex-col gap-1">{t13}{t16}{t17}</div>;
    $[25] = t13;
    $[26] = t16;
    $[27] = t17;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] !== t12 || $[30] !== t18) {
    t19 = <div className="flex items-center gap-4">{t12}{t18}</div>;
    $[29] = t12;
    $[30] = t18;
    $[31] = t19;
  } else {
    t19 = $[31];
  }
  let t20;
  if ($[32] !== primary || $[33] !== service.summary) {
    t20 = service.summary && <p className={cn("text-foreground leading-relaxed", primary ? "text-xs sm:text-sm" : "line-clamp-3 text-xs")}>{service.summary}</p>;
    $[32] = primary;
    $[33] = service.summary;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  let t21;
  if ($[35] !== primary || $[36] !== showFreeTier) {
    t21 = !primary && showFreeTier && <span className="text-status-success text-xs font-medium">Free tier included</span>;
    $[35] = primary;
    $[36] = showFreeTier;
    $[37] = t21;
  } else {
    t21 = $[37];
  }
  let t22;
  if ($[38] !== t19 || $[39] !== t20 || $[40] !== t21) {
    t22 = <div className="flex min-w-0 flex-1 flex-col gap-3">{t19}{t20}{t21}</div>;
    $[38] = t19;
    $[39] = t20;
    $[40] = t21;
    $[41] = t22;
  } else {
    t22 = $[41];
  }
  let t23;
  if ($[42] !== isComingSoon || $[43] !== offeringSummary || $[44] !== primary || $[45] !== service.id || $[46] !== showFreeTier) {
    t23 = primary && <div className="hidden shrink-0 flex-col items-end justify-between gap-2 text-right sm:flex"><div className="flex flex-col items-end gap-1">{showFreeTier && <span className="text-status-success text-sm font-medium">Free tier included</span>}{!isComingSoon && offeringSummary && offeringSummary.tierCount > 0 && <span className="text-muted-foreground text-xs">{offeringSummary.tierCount} tiers available</span>}</div><div className="relative z-20"><Button asChild={true} size="default" className="w-fit"><Link href={`/services/${service.id}` as Route}>Get Started</Link></Button></div></div>;
    $[42] = isComingSoon;
    $[43] = offeringSummary;
    $[44] = primary;
    $[45] = service.id;
    $[46] = showFreeTier;
    $[47] = t23;
  } else {
    t23 = $[47];
  }
  let t24;
  if ($[48] !== t22 || $[49] !== t23 || $[50] !== t8) {
    t24 = <CardContent className={t8}>{t22}{t23}</CardContent>;
    $[48] = t22;
    $[49] = t23;
    $[50] = t8;
    $[51] = t24;
  } else {
    t24 = $[51];
  }
  let t25;
  if ($[52] !== t24 || $[53] !== t3 || $[54] !== t6) {
    t25 = <Card className={t3}>{t6}{t24}</Card>;
    $[52] = t24;
    $[53] = t3;
    $[54] = t6;
    $[55] = t25;
  } else {
    t25 = $[55];
  }
  return t25;
}
export { ServiceFeaturedCard };